import { IconButton } from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import { ArrowBack } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import { DATATEST } from "constants/integration";
import { formatMessage } from "lib/globalize-util";
import React from "react";
import Tooltip from "components/tooltip";
import { connect } from "react-redux";
import { setShowDoors } from "actions/tool-panel/draft/actions";
import { SetShowDoors } from "actions/tool-panel/draft/types";
import { SelectedDimension } from "./dimensions-tool-panel";

type PassedProps = {
    selectedDimension?: SelectedDimension;
    onBack: () => void;
    onClosePanel: () => void;
};

type ReduxProps = {
    showDoors: boolean;
    setShowDoors: SetShowDoors;
};

export const DimensionsToolPanelHeader: React.FunctionComponent<PassedProps & ReduxProps> = ({
    selectedDimension,
    onBack,
    onClosePanel,
    showDoors,
    setShowDoors,
}) => (
    <div className="dimensionsHeaderContainer">
        {selectedDimension ? (
            <div className="dimensionTitle">
                <div className="dimensionBack">
                    <IconButton className="dimensionsBackButton" onClick={onBack}>
                        <ArrowBack />
                    </IconButton>
                    <Tooltip title={selectedDimension.label} placement="bottom">
                        <h2 className="dimensionsHeaderName">{selectedDimension.label}</h2>
                    </Tooltip>
                </div>
                <IconButton className="dimensionsCloseButton" onClick={onBack}>
                    <CloseIcon />
                </IconButton>
            </div>
        ) : (
            <>
                <div className="dimensionTitle">
                    <h2 className="dimensionsHeader">{formatMessage("Door groupings")}</h2>
                    <IconButton className="dimensionsCloseButton" onClick={onClosePanel}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className="switchSection">
                    <Switch
                        checked={showDoors}
                        color="primary"
                        onChange={(e) => setShowDoors({ showDoors: e.target.checked })}
                        data-test={DATATEST.ASSORTMENTS.GROUPING.SHOW_DOORS}
                        id="show-doors"
                    />
                    <label htmlFor="show-doors" className="show-doors-label">
                        {formatMessage("Show doors")}
                    </label>
                </div>
            </>
        )}
    </div>
);

export const DimensionToolPanelHeaderContainer = connect<{}, {}, PassedProps>(
    (state) => ({ showDoors: state.dimensionsPanel.draft.showDoors }),
    {
        setShowDoors,
    }
)(DimensionsToolPanelHeader);
